import type { ReactNode, Ref } from 'react';
import { RoamMark, type RoamMarkTone } from '@/components/branding/RoamMark';
import { cn } from '@/lib/utils';
import { PHONE_FLOATING_BAR_NAV_CLASS, PHONE_FLOATING_BAR_PANEL_CLASS } from './phoneFloatingBar';

/** A phone-style pill that floats above the page, clear of the screen edges. */
export function FloatingTripBar({
  label,
  children,
  navRef,
  className,
}: {
  label: string;
  children: ReactNode;
  navRef?: Ref<HTMLElement>;
  className?: string;
}) {
  return (
    <nav
      ref={navRef}
      aria-label={label}
      data-trip-phone-floating-chrome
      className={PHONE_FLOATING_BAR_NAV_CLASS}
    >
      <div data-phone-floating-bar-panel className={cn(PHONE_FLOATING_BAR_PANEL_CLASS, className)}>
        {children}
      </div>
    </nav>
  );
}

/** A quiet color tile. The dock stays the object; the mark only identifies the action. */
export function TripDockMark({
  tone,
  children,
}: {
  tone: Extract<RoamMarkTone, 'trip' | 'sleep' | 'details' | 'map' | 'overview'>;
  children: ReactNode;
}) {
  return <RoamMark tone={tone}>{children}</RoamMark>;
}
